export const isSubArray = (arr, subArr) => {
  return subArr.some((item) => arr.includes(item));
};

export default isSubArray;
